import {h, Fragment} from "preact"
import { useFacets, useProductFilters } from "@nosto/preact"
import Facet from "./Facet"
import RangeFacet from "./RangeFacet"
import Icon from "./elements/Icon"
import SortDropdown from "./elements/SortDropdown"

export const toggleButtonId = "toggle-mobile-sidebar"

function ToggleSidebarButton({ className }) {
    return (
        <label
        // ns-absolute
            className={`ns-act-btn ns-close-sidebar ns-d-block ns-d-md-none ns-text-align-right ns-align-items-center ns-clickable ns-font-3 ns-p-0 ${className}`}
            aria-label="Close filters"
            for={toggleButtonId}
            tabIndex="0"
        >
            <Icon name="close" />
        </label>
    )
}

export default function SideBar({ toggledFacet, setToggledFacet }) {
    const { loading, facets } = useFacets()
    const { removeAll } = useProductFilters()

    function closeSidebar() {
        const closeBtn = document.querySelector('.ns-close-sidebar');
        if(closeBtn){
            closeBtn.click();
        }
    }

    return facets?.length > 0 ? (
        <>
            <input type="checkbox" id={toggleButtonId} class="ns-facet-sidebar-toggle ns-d-none" />
            <label
                class="ns-sidebar-backdrop ns-fixed ns-w-100 ns-h-100 ns-background-black ns-d-none"
                for={toggleButtonId}
            />
            <div
            //  ns-col-3 ns-col-l-2 ns-d-md-block
                class="ns-sidebar-wrapper ns-d-none ns-h-100"
                // style={loading ? "opacity: 0.3;" : ""}
            >
                {/* ns-p-4 */}
                <div class="ns-sidebar-content ns-relative ns-background-white ns-h-100 ns-mr-0 ns-mr-md-auto">
                    <div class="ns-sidebar-header ns-d-flex ns-justify-content-between ns-align-items-center">
                        <span class="ns-font-medium ns-font-5 ns-color-black">FILTERS</span>
                        <ToggleSidebarButton />
                    </div>
                    <div class="ns-sidebar-menu">
                    {/* ns-d-flex */}
                        <ul class="ns-list-unstyled ns-p-0 ns-m-0" tabindex="0" id="nosto-facets-container">
                            <SortDropdown toggledFacet={toggledFacet} setToggledFacet={setToggledFacet}/>
                            {facets?.map(facet => {
                                switch (facet.type) {
                                    case "terms":
                                        return <Facet key={facet.id} facet={facet} toggledFacet={toggledFacet} setToggledFacet={setToggledFacet}/>
                                    case "stats":
                                        return <RangeFacet key={facet.id} facet={facet} toggledFacet={toggledFacet} setToggledFacet={setToggledFacet}/>
                                    default:
                                        return null
                                }
                            })}
                        </ul>
                    </div>
                    <div class="ns-sidebar-footer ns-w-100 flex gap-2 px-5 py-4 border-t justify-center border-grey-3">
                        <span
                        // ns-col-2 ns-text-align-right ns-color-link ns-font-4 ns-ml-2 ns-mr-0 ns-ml-auto
                        class="ns-anchor"
                        onClick={() => {
                            removeAll()
                        }}
                    >
                        CLEAR ALL
                    </span>
                    <span class="ns-apply-btn" onClick={closeSidebar}>APPLY</span>
                    </div>
                </div>
            </div>
        </>
    ) : (
        ""
    )
}
